export default [
  {
    name: 'queryGjFlight',
    method: 'post',
    desc: '获取国际航班列表',
    path: '/obt/queryGjFlight',
    params: {
      aduNum: '1',
      arriveAirport: '',
      cabinType: '',
      chdNum: '0',
      departAirport: '',
      departDate: '',
      infNum: '0',
      returnDate: '',
      travelType: '1',
      tripType: '1'
    }
  }, {
    name: 'matchVipClzcByGjFlight',
    method: 'post',
    desc: '国际机票是否违背',
    path: '/obt/matchVipClzcByGjFlight',
    params: {
      minZj: '0',
      cacheId: '',
      cplx: '10902'
    },
    loading: '0'
  },
  // POST /obt/bookGjOrder
  // 国际机票下单
  {
    name: 'bookGjOrder',
    method: 'post',
    desc: '国际机票下单',
    path: '/obt/bookGjOrder',
    params: {
      'adAirportFee': '',
      'adPj': '',
      'adTax': '',
      'callEmpid': '',
      'callNum': '',
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsqdRemark': '',
      'corpId': '',
      'costCenterCode': '',
      'costCenterId': '',
      'costCenterName': '',
      'empRank': 0,
      'ifSameOrder': '',
      'international': '',
      'linkCtPhone': '',
      'linkEmail': '',
      'linkMan': '',
      'linkTel': '',
      'orderFrom': '',
      'postCode': '',
      'postCompId': '',
      'postOrderId': '',
      'projectCode': '',
      'projectId': '',
      'projectName': '',
      'psgList': [
        // {
        // 	'born': '',
        // 	'costCenterCode': '',
        // 	'costCenterId': '',
        // 	'costCenterName': '',
        // 	'empId': '',
        // 	'fsEmpId': '',
        // 	'idType': '',
        // 	'idno': '',
        // 	'nation': '',
        // 	'nationHx': '',
        // 	'passportPeriod': '',
        // 	'phoneNumber': '',
        // 	'placeOfIssue': '',
        // 	'psgName': '',
        // 	'psgType': '',
        // 	'sex': ''
        // }
      ],
      'rangeList': [
        // {
        // 	'adPj': '',
        // 	'adTax': '',
        // 	'cabinKey': '',
        // 	'cacheId': '',
        // 	'flightKey': '',
        // 	'priceId': '',
        // 	'rangeType': '',
        // 	'reasonCode': '',
        // 	'reasonDesc': '',
        // 	'recomCabin': '',
        // 	'recomDepartTime': '',
        // 	'recomFlightNo': '',
        // 	'recomPrice': 0
        // }
      ],
      'rangeType': '',
      'reciAddr': '',
      'reciPhone': '',
      'reciPient': '',
      'remark': '',
      'routeId': '',
      'sendMode': '',
      'subjectCode': '',
      'tktlTime': '',
      'travelStandard': '',
      'tripType': ''
    },
  },

  /****************新接口**************/

  // POST /obt/plane/shopping/gj/matchVipClzc
  // 匹配差旅政策
  {
    name: 'matchVipClzc',
    method: 'post',
    desc: '国际机票匹配差旅政策',
    path: '/obt/plane/shopping/gj/matchVipClzc',
    params: {
      'minZj': '',
      'corpId': '',
      'flightReqId': ''//航班查询请求id不能为空
    },
    loading: '0'
  },
  // POST /obt/plane/shopping/gj/queryFlightMinPrice
  // 航班数据查询（第一屏）
  {
    name: 'queryFlightMinPrice',
    method: 'post',
    desc: '航班数据查询（第一屏）',
    path: '/obt/plane/shopping/gj/queryFlightMinPrice',
    params: {
      'departAirport': '',
      'arriveAirport': '',
      'departDate': '',
      'travelType': '',//是否往返程 2往返程 空或1单程 ,
      'returnDate': '',//返程日期日期不能为空 ,
      'corpId': '',
      'cabinType': '',
      'tripType': '1',
      'showStop': 1,//是否经停 1显示0不显示 ,
      'infNum': 0,//婴儿数量 ,
      'chdNum': 0,// 儿童数量 ,
      'aduNum': 0,//成人数量 ,
      'airline': '',//航司二字代码 ,
      'requestId': '',//请求标记，第二次请求时回传，为第一次请求返回的值，避免重复查询数据库 ,
      'startCount': 0,//开始条数 ,
      'count': 20,//显示多少条数据
      'sharFlight': 1,
      // 'showChdPrice': '0'
    },
    loading: '0',
    continue: true,
  },
  // POST /obt/plane/shopping/gj/queryFlightRule
  // 机票查询退改签规则
  {
    name: 'queryFlightRule',
    method: 'post',
    desc: '机票查询退改签规则',
    path: '/obt/plane/shopping/gj/queryFlightRule',
    params: {
      'flightReqId': '',//航班查询请求id不能为空 ,
      'flightSn': '',//航班序号
      'cabin': '',
      'priceId': ''
    }
  },
  // POST /obt/plane/shopping/gj/queryMoreCabin
  // 根据航班查询更多舱位信息（第二屏）
  {
    name: 'queryMoreCabin',
    method: 'post',
    desc: '根据航班查询更多舱位信息（第二屏）',
    path: '/obt/plane/shopping/gj/queryMoreCabin',
    params: {
      'flightSn': '',//航班序号 ,
      'flightReqId': '',//航班查询请求id不能为空 ,
      'corpId': '',
      'cabinType': '',
      'tripType': '',
      'infNum': 0,
      'chdNum': 0,
      'aduNum': 0,
      'requestId': ''//请求标记，第二次请求时回传，为第一次请求返回的值，避免重复查询数据库
    },
    loading: '0',
    continue: true,
  },
  // POST /obt/plane/tkOrder/bookGj
  // 国际机票下单(新)
  {
    name: 'bookGj',
    method: 'post',
    desc: '国际机票下单(新)',
    path: '/obt/plane/tkOrder/bookGj',
    params: {
      'rangeList': [
        // {
        // 	'flightSn': '',
        // 	'flightReqId': '',
        // 	'priceId': '',
        // 	'cabinCode': '',
        // 	'reasonCode': '',
        // 	'reasonDesc': '',
        // 	'rangeType': '',
        // 	'recomFlightNo': '',
        // 	'recomCabin': '',
        // 	'recomDepartTime': '',
        // 	'recomPrice': 0
        // }
      ],
      'psgList': [
        // {
        // 	'psgName': '',
        // 	'psgType': '',
        // 	'idType': '',
        // 	'idno': '',
        // 	'phoneNumber': '',
        // 	'sex': '',
        // 	'born': '',
        // 	'nationHx': '',
        // 	'nation': '',
        // 	'passportPeriod': '',
        // 	'placeOfIssue': '',
        // 	'empId': '',
        // 	'fsEmpId': ''
        // }
      ],
      'travelStandard': '',
      'tripType': '',
      'rangeType': '',
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsqdRemark': '',
      'routeId': '',
      'subjectCode': '',
      'ifSameOrder': '',
      'costCenterId': '',
      'costCenterCode': '',
      'costCenterName': '',
      'projectId': '',
      'projectCode': '',
      'projectName': '',
      'orderFrom': '',
      'linkman': '',
      'linkTel': '',
      'linkEmail': '',
      'sendMode': '',
      'reciPient': '',
      'reciPhone': '',
      'reciAddr': '',
      'postCode': '',
      'postCompId': '',
      'postOrderId': '',
      'corpId': '',
      'booker': '',
      'callNum': '',
      'callEmpid': ''
    },
    loading: '0'
  },


  /****************国际需求单***************/
  {
    name: 'tkNeedOrderAdd',
    method: 'post',
    desc: '国际需求单生成',
    path: '/obt/tkNeedOrderAdd',
    params: {
      'adultNum': 0,
      'babyNum': 0,
      'cabin': 0,
      'childNum': 0,
      'content': '',
      'expectBudget': 0,
      'linkEmail': '',
      'linkTel': '',
      'linkman': '',
      'orderFrom': '',
      'psgType': 0,
      'tkNeedRanges': [
        // {
        // "arriveAirport": "",
        // "arriveAirportName": "",
        // "arriveCity": "",
        // "arriveCityName": "",
        // "arriveTime": "",
        // "departAirport": "",
        // "departAirportName": "",
        // "departCity": "",
        // "departCityName": "",
        // "departTime": ""
        // }
      ],
      'tripType': 0,
      'voyageType': 0,
      international: 1
    }
  },

  {
    name: 'getPoundageForRefundChange',
    method: 'post',
    desc: '国际机票退票获取单价退费价格，返-1不可以退',
    path: '/obt/gj/getPoundageForRefundChange',
    params: {
      airline: '',//航司二字码
      cabin: '',//舱位
      departDate: '',//出发日期
      flag: '',//1退票 2改签 ,
      orderId: '',//订单号
      salePrice: '',//销售价
      corpId: '',//公司id
      rangeIds: '',//航段id
    }
  },
  {
    name: 'applyRefund',
    method: 'get',
    desc: '获取可退票的航段和乘机人',
    path: '/obt/gj/applyRefund',
    params: {
      orderId: ''
    }
  },
  {
    name: 'refundAdd',
    method: 'post',
    desc: '退票提交',
    path: '/obt/gj/refundAdd',
    params: {
      orderId: '',
      groupNumber: '',// 预算团号
      orderFrom: '',// 订单来源
      psgIdList: '',// 乘机人id
      rangeIdList: '',// 航段id
      refundApplyRemark: '',// 退票申请备注
      refundProveUrl: '',// 退票证明
      refundReasonVip: '',// 退票原因
      refundResaon: '',// 退票原因
      refundType: '',// 退票类型

    }
  },
  , {
    name: 'tkChangeV3QueryFlight',
    method: 'post',
    desc: '获取航班列表',
    path: '/obt/gj/tkChangeV3QueryFlight',
    params: {
      'alterType': 1,//改签类别1改期2升舱
      'arriveAirport': '',
      'departAirport': '',
      'departDate': '',
      'orderId': '',
      'rangeId': '',//改签航段id 升舱时必传
      'single': ''//改签航班查询类型 0中转单程提交 1中转全程提交 2单票全程
    }
  },
  {
    name: 'tkChangeV3QueryFlightPrice',
    method: 'post',
    desc: '获取航班列表第带二屏',
    path: '/obt/gj/tkChangeV3QueryFlightPrice',
    params: {
      'cacheId': '',//缓存id
      'flightNo': '',//航班号
      'tripType': '',//1因公2因私
      'cabinType': '',//舱位类型
      'corpId': '',//企业id
    }
  },
  {
    name: 'tkChangeOrderAdd',
    method: 'post',
    desc: '提交机票改签单',
    path: '/obt/gj/tkChangeOrderAdd',
    params: {
      'alterType': 0,
      'changeProveUrl': '',
      'changeReason': '',
      'changeReasonCode': '',
      'changeReasonCodeVip': '',
      'changeReasonVip': '',
      'changeType': '',
      'orderFrom': '',
      'orderId': '',
      'psgIds': '',
      'groupNumber': '',
      'changeApplyRemark': '',
      'ranges': [
        // {
        // "cabinKey": "",
        // "cacheId": "",
        // "nCabin": "",
        // "nDepartTime": "",
        // "nFlightNo": "",
        // "nShareFlightNo": "",
        // "nStopAirport": "",
        // "nStopArriveTime": "",
        // "nStopDepartTime": "",
        // "rangeId": ""
        // }
      ]
    }
  },
  {
    name: 'tkRefundCgtj',
    method: 'post',
    desc: '提交机票改签单',
    path: '/obt/gj/tkRefundCgtj',
    params: {
      orderId: '',//退票订单id 必传
      version: '',//版本号
      online: '',//线上线下提交 0或空线下 1线上
      purchaseRefundType: '',//退票类型 1自愿 2非自愿
      purchaseRefundResaon: '',//退票原因
      purchaseRefundReasonCode: '',//退票原因代码
      purchaseRefundProveUrl: '',//退票证明url
      purchaseRefundPoundage: '',//退票手续费
    }
  },


]
